<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_VIEW_DATA')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Yêu cầu cung cấp chứng từ</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button class="font-medium f12 btn btn-outline-secondary" @click="exportExcel">
          <i class="bx bx-download"></i> Xuất excel
        </button>
        <button
          type="button"
          class="f12 font-medium btn btn-outline-secondary"
          @click="fetchByRisk"
        >
          GD bị cảnh báo quá hạn
        </button>
        <button
          type="button"
          class="f12 font-medium btn btn-outline-secondary"
          v-show="
            selected.length > 0 && dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_ASSIGN_USER')
          "
          @click="showAssignList(selected)"
        >
          Gán NV xử lý
        </button>
        <button
          type="button"
          class="f12 font-medium btn btn-outline-secondary"
          v-show="
            selected.length > 0 && dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_SELF_ASSIGN')
          "
          @click="assignToMe(selected)"
        >
          Nhận việc
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian thanh toán
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input v-model.trim="filter.key" placeholder="Tên/Email/SĐT" />
          </div>
          <div class="form-group">
            <input v-model.trim="filter.transactionTxnId" placeholder="ID giao dịch" />
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="filter.paymentMethod"
              :options="optionPaymentMethod"
              :settings="{ placeholder: 'Phương thức thanh toán', multiple: false }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <select2-multiple-control
              @change="changeFilterAmount"
              :options="optionAmounts"
              :settings="{ placeholder: 'Số tiền', multiple: false }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="filter.riskType"
              :options="optionTypeRisk"
              :settings="{ placeholder: 'Loại rủi ro', multiple: false }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="filter.transactionStatus"
              :options="optionTransStt"
              :settings="{ placeholder: 'Trạng thái giao dịch' }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="filter.status"
              :options="optionLicenceStt"
              :settings="{ placeholder: 'Trạng thái YCCT' }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2
              v-model="filter.regionId"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filter.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng yêu cầu</b>: {{ pagination.total }}</span> |
            <span><b>Chưa cung cấp</b>: {{ summary.noProvider }}</span> |
            <span><b>Hoàn thành </b>: {{ summary.complete }}</span> |
            <span><b>Chờ VH duyệt</b>: {{ summary.waitingOpApprove }}</span> |
            <span><b>Chờ GĐV duyệt</b>: {{ summary.waitingDirectorApprove }}</span> |
            <span><b>Từ chối</b>: {{ summary.reject }}</span>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataTable"
              :fields="filterTable"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #head(selected)>
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="selectAll"
                    id="selectedLs"
                  />
                  <label class="custom-control-label" for="selectedLs"></label>
                </div>
              </template>
              <template #cell(selected)="data">
                <b-form-checkbox v-model="selected" :value="data.item.licenceId"></b-form-checkbox>
              </template>
              <template #cell(index)="data">
                {{ (search.pageIndex - 1) * search.pageSize + (data.index + 1) }}
              </template>
              <template #cell(time)="data">
                <p><b>Tạo</b>: {{ data.item.createdTime }}</p>
                <p><b>Cập nhật</b>: {{ data.item.updateAt | formatDate('DD/MM/YYYY HH:mm:ss') }}</p>
                <p v-if="data.item.transInfo.approvedAt">
                  <b>Duyệt</b>: {{ data.item.transInfo.approvedAt }}
                </p>
                <p><b>Thanh toán</b>: {{ data.item.transInfo && data.item.transInfo.tranDate }}</p>
              </template>
              <template #cell(amount)="data">
                {{ data.item.transInfo && data.item.transInfo.amount | transformMoney }}
              </template>
              <template #cell(merchant)="data">
                {{ data.item.merchantInfo.name }}
              </template>
              <template #cell(saleAssign)="data">
                <div v-if="data.item.assigneeInfo.name">
                  {{ data.item.assigneeInfo.name }} <br />
                  <span class="text-primary">{{ data.item.assigneeInfo.email }}</span>
                </div>
              </template>
              <template #cell(nameTrans)="data">
                {{ data.item.transInfo.holderName }}
              </template>
              <template #cell(idTrans)="data">
                {{ data.item.transInfo.tranTxnId }}
              </template>
              <template #cell(isMerchantUpload)="data">
                {{ data.item.isMerchantUpload === true ? 'đã upload CT' : 'Chưa upload CT' }}
              </template>
              <template #cell(sttTrans)="data">
                {{ data.item.transInfo.status | transformData(optionTransStt) }}
              </template>
              <template #cell(paymentMethodText)="data">
                {{ data.item.transInfo.paymentMethodText }}
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | transformData(optionLicenceStt) }}
                </span>
                <span
                  v-if="checkRiskExpire(data.item.createdTime, data.item.status)"
                  class="badge REJECT mt-1"
                >
                  Cảnh báo quá hạn
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="toDetail(data.item)"> Chi tiết </b-dropdown-item>
                  <b-dropdown-item @click="copyLink(data.item.licenceId)">
                    Copy link
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="showAssignList([data.item.licenceId])"
                    v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_ASSIGN_USER')"
                    >Gán NV xử lý
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="assignToMe([data.item.licenceId])"
                    v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_SELF_ASSIGN')"
                    >Nhận việc
                  </b-dropdown-item>
                  <b-dropdown-item @click="checkStatus(data.item.licenceId)"
                    >Kiểm tra TT Thanh toán
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="mr-2 fl-right"
          v-model="search.pageIndex"
          :total-rows="pagination.total"
          :per-page="search.pageSize"
        ></b-pagination>
      </div>
    </div>
    <b-modal id="assign-modal">
      <template #modal-header="{ close }">
        <h5>Gán nhân viên xử lý</h5>
        <b-button size="sm" variant="outline-light" @click="close()">x</b-button>
      </template>

      <template #default="{}">
        <div class="form-group row">
          <div class="col-sm-12">
            <b-input-group>
              <b-form-input
                placeholder="Tên/Email"
                v-model="searchSale.textSearch"
                @input="listStaff"
                @keyup.enter="listStaff"
              >
              </b-form-input>
              <b-input-group-append>
                <b-button variant="outline-secondary">Tìm kiếm</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div class="table-responsive m-3" style="max-height: 50vh; overflow-y: auto">
            <b-table
              hover
              :items="dataSale"
              :fields="fields"
              :sticky-header="true"
              class="b-table-select-single"
              id="table-sale"
              selectable
              select-mode="single"
              @row-selected="onStaffSelected"
              :per-page="searchSale.limit"
              :current-page="searchSale.page"
              small
            >
            </b-table>
          </div>
          <b-pagination
            class="ml-3"
            v-model="searchSale.page"
            :total-rows="total"
            :per-page="searchSale.limit"
            aria-controls="table-sale"
          ></b-pagination>
        </div>
      </template>

      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="primary" @click="assignToSale" :disabled="idAssign === ''">
          Xác nhận
        </b-button>
        <b-button size="sm" variant="light" @click="cancel()"> Huỷ </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import { LicenceService } from '@/services/licence.service'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  const fieldsTable = [
    { key: 'selected', label: '' },
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'time', label: 'Thời gian' },
    { key: 'amount', label: 'Số tiền' },
    { key: 'merchant', label: 'Merchant' },
    { key: 'saleAssign', label: 'NV xử lý' },
    { key: 'nameTrans', label: 'Tên chủ thẻ' },
    { key: 'idTrans', label: 'ID giao dịch', class: 'text-center' },
    { key: 'sttTrans', label: 'Trạng thái giao dịch' },
    { key: 'paymentMethodText', label: 'Phương thức thanh toán' },
    { key: 'isMerchantUpload', label: 'MC upload CT' },
    { key: 'riskTypeText', label: 'Loại rủi ro' },
    { key: 'status', label: 'Trạng thái YCCT' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      return {
        showLoading: false,
        loading: false,
        filter: {},
        search: {
          pageIndex: 1,
          pageSize: 20,
        },
        pagination: {
          total: 0,
        },
        summary: {},
        dataTable: [],
        selected: [],
        fieldsTable,
        filterTable: fieldsTable,
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dataProvince: [],
        dataConfigRegion: [],
        optionTypeTrans: Config.typeTransaction,
        optionTypeRisk: Config.typeRisk,
        optionTransStt: Config.transactionStt,
        optionLicenceStt: Config.licenceStt,
        optionPaymentMethod: Config.paymentMethods,
        optionAmounts: Config.optionAmounts,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        fields: [
          {
            label: 'Tên',
            key: 'name',
            thStyle: { 'min-width': '140px', 'word-break': 'break-word' },
          },
          { label: 'Email', key: 'userName' },
          { label: 'Tỉnh/Thành phố', key: 'provinceName' },
        ],
        idAssignLicence: [],
        idAssign: '',
        searchSale: {
          limit: 20,
          page: 1,
          userId: JSON.parse(localStorage.getItem('userData')).userId,
        },
      }
    },
    components: {
      DateRangePicker,
    },
    created() {
      this.getRegions()
      this.fetchData()
      this.listStaff()
    },
    mixins: [prepareQueryParamsMixin],
    computed: {
      selectAll: {
        get: function () {
          return this.selected.length === this.dataTable.length
        },
        set: function (value) {
          var selected = []
          if (value) {
            selected = this.dataTable.map(item => item.licenceId)
          }
          this.selected = selected
        },
      },
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    watch: {
      'search.pageIndex': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    methods: {
      changeFilterAmount(val) {
        const spl = val.split('-')
        if (spl.length > 0) {
          if (spl[1] === 'max') {
            delete this.filter.toAmount
            this.filter.fromAmount = Number(spl[0])
          } else {
            this.filter.fromAmount = Number(spl[0])
            this.filter.toAmount = Number(spl[1])
          }
        }
      },
      checkRiskExpire(date, status) {
        const startDayCheck = moment().startOf('day').add(-3, 'days')
        const statusCheck = 'NO_PROVIDE'
        const compareDate = moment(date, 'DD/MM/YYYY HH:mm')
        return statusCheck === status && compareDate.isBefore(startDayCheck)
      },
      fetchByRisk() {
        this.search = {
          pageSize: 50,
          pageIndex: 1,
        }
        this.filter = {
          status: ['NO_PROVIDE'],
          toCreatedDate: moment().startOf('day').add(-3, 'days').valueOf(),
        }
        this.fetchData()
      },
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
          } else this.dataProvince = []
        } catch (error) {}
      },
      async checkStatus(id) {
        try {
          this.showLoading = true
          const response = await LicenceService.checkStatus(id)
          this.showSuccessMx(`Trạng thái thông tin: ${response.data.statusText}`)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      showAssignList(arr) {
        this.$bvModal.show('assign-modal')
        this.idAssignLicence = arr
      },
      onStaffSelected(item) {
        this.idAssign = item.length > 0 ? item[0].userId : ''
      },
      async listStaff() {
        try {
          const data = await StaffService.getListLowerGrade(this.searchSale)
          if (data.success) {
            this.total = data.data.length
            this.dataSale = data.data
          }
        } catch (error) {
          console.log(error)
        }
      },
      async assignToSale() {
        try {
          this.$bvModal.hide('assign-modal')
          this.showLoading = true
          const data = await LicenceService.assignSale({
            licenceIds: this.idAssignLicence,
            userId: this.idAssign,
            isSelfAssign: false,
          })
          if (data.success) {
            this.showSuccessMx('Gán nhân viên xử lý thành công')
            this.selected = []
            await this.fetchData()
          } else {
            this.showFailMx(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
        }
      },
      async assignToMe(licenceIds) {
        try {
          this.showLoading = true
          const data = await LicenceService.assignSelf({
            licenceIds,
            userId: this.searchSale.userId,
            isSelfAssign: true,
          })
          if (data.success) {
            this.showSuccessMx('Nhận việc thành công')
            this.selected = []
            await this.fetchData()
          } else {
            this.showFailMx(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
        }
      },
      copyLink(id) {
        navigator.clipboard.writeText(
          `${window._env_?.VUE_APP_BASE_URL ?? process.env.VUE_APP_BASE_URL}/mc-ccct/${id}`
        )
        this.showSuccessMx('Copy link thành công')
      },
      transfromDate() {
        this.filter.fromDate = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.filter.toDate = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      async fetchData() {
        try {
          this.loading = true
          this.search.filter = this.filter
          const data = await LicenceService.listLicence(this.search)
          if (data.success) {
            this.dataTable = data.data
            this.pagination.total = data.totalPage.total
            this.summary = data.metaData ?? {}
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.pageIndex = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          pageSize: 50,
          pageIndex: 1,
        }
        this.filter = {}
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      toDetail(item) {
        window.open(`/list-licence/${item.licenceId}`, '_blank')
      },
      async exportExcel() {
        try {
          this.showLoading = true
          if (this.dateRange.startDate == null || this.dateRange.endDate == null) {
            this.showFailMx('Vui lòng chọn thời gian thanh toán')
          } else if (this.filter.fromDate - this.filter.toDate > 7889229000) {
            this.showFailMx('Vui lòng chọn thời gian thanh toán trong vòng 3 tháng')
          } else {
            delete this.search.pageIndex
            delete this.search.pageSize
            await LicenceService.exportLicence(this.search)
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
        }
      },
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
  }
</script>
